module.exports = __webpack_public_path__ + "static/img/IMG_20160917_152357.5576c513.jpg";